import { Navigate } from 'react-router-dom';
import { FeedbackInbox } from '@/components/feedback-inbox';
import { useOrgContext } from './layout';

/** Feedback members sent to this organization: its admins; parent admins read only. */
export function OrgFeedbackPage() {
  const { org, canManage, role } = useOrgContext();
  if (!canManage && role !== null) return <Navigate to=".." replace />;
  return <FeedbackInbox scope={{ kind: 'org', orgId: org.id }} canManage={canManage} />;
}
